let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lgmw4")).then(() => parcelRequire('bHzRo'));